<div class="container">
    <div class="row">
        <div class="col-xs-12 text-center" style="border:1px solid lightgray; border-radius: 10px;min-height: 95vh;">
            <div style="margin-top:3%">
                <img src="assets/app-content/img/day79-coffee.png" style="height:260px" alt="Meeting End">
                <h2>Thank you for attending the call. You can now close this window.</h2>
            </div>
        </div>
    </div>
</div>
